import { strToFixedFloat } from 'services/utils'

import {
  GET_ACCOUNT_BALANCE_SUCCESS,
  GET_ACCOUNT_BALANCE_LOADING,
  GET_ACCOUNT_BALANCE_ERROR
} from '../actions/actionTypes'

const initialState = {
  amount: 0,
  income: 0,
  loading: false
}

const balance = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCOUNT_BALANCE_LOADING:
      return { ...state, loading: true }
    case GET_ACCOUNT_BALANCE_SUCCESS:
      return {
        ...state,
        amount: strToFixedFloat(action.data.amount),
        income: strToFixedFloat(action.data.income),
        loading: false
      }
    case GET_ACCOUNT_BALANCE_ERROR:
      return { ...state, loading: false }
    default:
      return state
  }
}

export default balance
